import { alpha, Theme } from '@mui/material'

const classes = {
  blurSkrim: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.ui.onPrimaryFixedVariant, 0.08),
    backdropFilter: 'blur(5px)',
    width: '100vw',
    height: '100vh',
    position: 'fixed',
  }),
  dialogPaper: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceVariant,
    borderRadius: theme.spacing(1.5),
  }),
  dialogActions: (theme: Theme, hasMultipleActions: boolean) => ({
    backgroundColor: theme.palette.ui.surfaceContainer,
    padding: theme.spacing(2),
    justifyContent: hasMultipleActions ? 'space-between' : 'center',
  }),
  closeButton: (theme: Theme) => ({
    marginLeft: theme.spacing(-1),
    color: theme.palette.text.secondary,
  }),
  titleContainer: {
    flex: 1,
  },
  contentContainer: (theme: Theme) => ({
    paddingX: 3,
    paddingY: 5,
    rowGap: 2,
    justifyContent: 'center',
    backgroundColor: theme.palette.ui.surfaceVariant,
  }),
  headerContainer: (theme: Theme, showCloseIcon: boolean) => ({
    justifyContent: showCloseIcon ? 'flex-start' : 'center',
    alignItems: 'center',
    gap: 2,
    paddingX: 2,
    paddingY: 1,
    minHeight: '64px',
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
  }),
  titleText: (showCloseIcon: boolean) => ({
    textAlign: 'center',
    ...(showCloseIcon ? { marginRight: 6 } : {}),
  }),
}

export default classes
